<template>
    <v-container>
        <v-layout>
            <v-flex lg8 mx-auto>
                <v-card class="green lighten-4 pa-6 mx-auto justify-center elevation-13">
                    <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="teal--text">문의하기</p></v-card-title>
                        <v-card class="pa-6 elevation-6">
                            <iframe name="hidden_iframe" id="hidden_iframe" style="display:none;"></iframe>
                            <form class="gform" method="POST" action="https://script.google.com/macros/s/AKfycbxmEcN9b66VSkQKjNRrXLn6wF7VIjnyVYBG2H2vd62jCdoHGGkd/exec" target="hidden_iframe">
                                <v-card-text>
                                    <v-layout row justify-space-between>
                                        <v-flex xs12><v-text-field id="name" name="name" label="이름"></v-text-field></v-flex>
                                        <v-flex xs5><v-text-field id="phoneNumber" name="phoneNumber" label="전화번호"></v-text-field></v-flex>
                                        <v-flex xs6><v-text-field id="email" name="email" label="이메일"></v-text-field></v-flex>
                                        <v-flex xs12><v-textarea id="message" name="message" label="메세지"></v-textarea></v-flex>
                                    </v-layout>
                                    <v-row class="justify-center">
                                        <button v-show="!submitted" @click="sendEmail()" class="button-success pure-button button-xlarge"><v-btn class="teal" large>제출<v-icon right>mdi-checkbox-marked-circle</v-icon></v-btn></button>
                                        <v-fade-transition>
                                            <p id="submitMessage" class="green--text mb-0" v-show="submitted">Your message was successfully sent. We will reply as soon as we can!</p>
                                        </v-fade-transition>
                                    </v-row>
                                </v-card-text>
                            </form>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
  name: 'ContactMessageUs',

  data: () => ({
      submitted: false
  }),
  methods: {
      sendEmail: function () {
          let that = this;
          this.submitted = true;
          setTimeout(function () {
              that.submitted = false;
          }, 4000);
      }
  }
};
</script>
<style scoped>
.pure-button {
    width: 30px;
    height: 20px;
}
#submitButton, #submitMessage {
    position: absolute;
}
</style>
